import React, { ComponentProps, useCallback } from 'react';
import { useDynamicModal } from 'components/DynamicModalProvider/useDynamicModal';
import { EditRealmModal } from 'SandboxModule/components/EditRealmModal';

export const useEditRealmModal = () => {
  const { openModal } = useDynamicModal();

  const openEditRealmModal = useCallback(
    (args: Omit<ComponentProps<typeof EditRealmModal>, 'onClose'>) => {
      openModal({
        modal: ({ isOpen: _isOpen, toggle }) => {
          return <EditRealmModal onClose={toggle} {...args} />;
        },
      });
    },
    [openModal],
  );

  return {
    openEditRealmModal,
  };
};
